"use strict";
/*
 * This file is part of ORY Editor.
 *
 * ORY Editor is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * ORY Editor is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with ORY Editor.  If not, see <http://www.gnu.org/licenses/>.
 *
 * @license LGPL-3.0
 * @copyright 2016-2018 Aeneas Rekkas
 * @author Aeneas Rekkas <aeneas+oss@aeneas.io>
 *
 */

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var Native = function Native(_a) {
  var _b = _a.state,
      item = _b.item,
      itemType = _b.itemType;
  return React.createElement("div", null, React.createElement("p", null, "This is a default plugin that handles native drag events of type", ' ', React.createElement("code", null, itemType), ".", React.createElement("br", null), "It contained the following payload:"), React.createElement("pre", null, JSON.stringify(item, null, 2)));
};
/**
 *
 * @param hover the item which the native element was dropped on
 * @param monitor the DropTargetMonitor as provided by react-dnd
 * @param component the React component of the item which the native element was dropped on
 */


var plugin = function plugin(hover, monitor, component) {
  return {
    Component: Native,
    name: 'ory/editor/core/content/default-native',
    version: '0.0.1',
    createInitialState: function createInitialState() {
      return {
        item: monitor && monitor.getItem(),
        itemType: monitor && monitor.getItemType()
      };
    }
  };
};

exports.default = plugin;